if ('serviceWorker' in navigator && !window.location.href.includes('localhost')) {
	navigator.serviceWorker.register('/service-worker.js')
}
